<ng-container *transloco="let t">
  <ld-base-modal [title]="displayTitle()" [showCloseButton]="true" (closeModal)="onClose()">
    <div modal-content>
      <div class="flex flex-col items-center gap-6">
        <ld-svg-icon [src]="approvedBadgeIcon" class="w-[74px] h-[74px]" aria-hidden="true" />

        <p class="font-dm text-ld-neutral-500 leading-relaxed text-center">
          {{ displayMessage() }}
        </p>

        <button
          id="congratulations-continue-btn"
          type="button"
          class="w-full px-5 py-2 text-base font-dm font-bold text-white bg-ld-primary rounded-[20px] uppercase tracking-[0.5px] hover:bg-ld-primary-600 transition-colors cursor-pointer"
          (click)="onClose()"
        >
          {{ buttonText() }}
        </button>
      </div>
    </div>
  </ld-base-modal>
</ng-container>
